module.exports = __webpack_public_path__ + "media/images/salespartner/partner-figure01-e39eddb195bf4bd7ebbaf460eaea5966.svg";